const webInfosSelector = (state) => state.webInfo.webInfos

export { webInfosSelector }
